import { transformStringToId } from 'utils'
import type { ClientFormState } from 'components/Forms/ImportClientForm/client-form'

// Define the initial state of the form
export const initialState: ClientFormState = {
  id: '',
  client_name: {
    value: '',
    error: undefined,
  },
  regional_standard_generation: true,
  retailer_adaption: true,
  sku_adaption: true,
}

// action types for reducer
const UPDATE_INPUT = 'UPDATE_INPUT'
const HANDLE_ERROR = 'HANDLE_ERROR'
const TOGGLE_CHECKBOX = 'TOGGLE_CHECKBOX'
const RESET_FORM = 'RESET_FORM'

// Define the actions for the form
type FormAction =
  | { type: typeof UPDATE_INPUT; payload: { value: string; shouldUpdateId: boolean } }
  | { type: typeof HANDLE_ERROR; payload: string }
  | { type: typeof TOGGLE_CHECKBOX; payload: { checkboxName: string; value: boolean } }
  | { type: typeof RESET_FORM; payload: ClientFormState }

// Create the form reducer
const formReducer = (state: ClientFormState, action: FormAction) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE_INPUT:
      const { value, shouldUpdateId } = payload
      return {
        ...state,
        id: shouldUpdateId ? transformStringToId(value) : state.id,
        client_name: {
          value: value,
          error: undefined,
        },
      }
    case HANDLE_ERROR:
      return {
        ...state,
        client_name: {
          ...state.client_name,
          error: payload,
        },
      }
    case TOGGLE_CHECKBOX:
      return {
        ...state,
        [payload.checkboxName]: payload.value,
      }
    case RESET_FORM:
      return payload
  }
}

// actions
export const updateInput = (value: string, shouldUpdateId: boolean): FormAction => ({
  type: UPDATE_INPUT,
  payload: {
    value,
    shouldUpdateId: shouldUpdateId,
  },
})
export const handleError = (error: string): FormAction => ({
  type: HANDLE_ERROR,
  payload: error,
})
export const toggleCheckbox = (checkboxName: string, value: boolean): FormAction => ({
  type: TOGGLE_CHECKBOX,
  payload: { checkboxName, value },
})

export const resetForm = (initialData: ClientFormState): FormAction => ({
  type: RESET_FORM,
  payload: initialData,
})

export default formReducer
